// src/App.js
import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import Home from './pages/Home'; // Home doesn't need lazy loading if it's a primary page

// Lazy load the Company and Contact pages
const Company = lazy(() => import('./pages/Company'));
const Contact = lazy(() => import('./pages/Contact'));

// Component to track page views on route change
function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when the route changes
    ReactGA.send({ hitType: 'pageview', page: location.pathname });
  }, [location]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize Google Analytics with your tracking ID
    ReactGA.initialize('G-SLS6GR6K7H'); // Replace with your actual GA tracking ID
  }, []);

  return (
    <Router>
      <Analytics /> {/* This will trigger page view tracking on route change */}
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/company" element={<Company />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
